

























import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Loading from './components/Loading.vue';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';

const auth = namespace('Auth');

@Component({
  components: {
    Loading,
    Header,
    Footer
  }
})
export default class App extends Vue {
  @auth.State
  loggedIn!: boolean;

  @auth.State
  loggingIn!: boolean;

  @auth.State
  loggingOut!: boolean;

  @auth.State
  checked!: boolean;

  @auth.Action
  logIn!: () => void;

  @auth.Action
  logOut!: () => void;

  @auth.Action
  checkLoggedIn!: () => void;

  @auth.Getter
  username!: string;

  @auth.Getter
  avatar!: string;

  mounted() {
    this.checkLoggedIn();
  }
}
